class RdVideo extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {
    this.video = this.querySelector('video');

    this.play = this.querySelector('button.play');
    this.pause = this.querySelector('button.pause');

    // play / pause button
    if (this.play && this.pause) {
      this.video.addEventListener('playing', (event) => {
        this.changeHandler();
      });
      this.video.addEventListener('pause', (event) => {
        this.changeHandler();
      });
      this.video.addEventListener('ended', (event) => {
        this.changeHandler();
      });

      this.play.addEventListener('click', (event) => {
        event.preventDefault();
        this.video.play();
      });
      this.pause.addEventListener('click', (event) => {
        event.preventDefault();
        this.video.pause();
      });
      this.changeHandler();
    }
    // autoplay on scroll into viewport
    else {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.video.play();
          } else {
            this.video.pause();
          }
        });
      }, { threshold: 0.5 });

      this.observer.observe(this);
    }
  }


  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }


  changeHandler() {
    this.play.classList.toggle('hidden', !this.video.paused);
    this.pause.classList.toggle('hidden', this.video.paused);
  }

}

// Define the new web component
if ('customElements' in window) {
  customElements.define('rd-video', RdVideo);
}
